import { http, formatURI } from './public'

export const apiServiceApi = {
    sync(){
        return http.fetchPost('/services/sys/api/sync', null)
    },
    findList(params){
        return http.fetchPost('/services/sys/api/findList', params)
    },
    findTree(){
        return http.fetchPost('/services/sys/api/findTree', null)
    },
    findByRoleId(params){
        return http.fetchPost('/services/sys/api/findByRoleId', params)
    },
    updateByRoleId(params){
        return http.fetchPost('/services/sys/api/updateByRoleId', params)
    }
}

export const menuServiceApi = {
    findList(params){
        return http.fetchPost('/services/sys/menu/findList', params)
    },
    findTree(){
        return http.fetchPost('/services/sys/menu/findTree', null)
    },
    update(params){
        return http.fetchPost('/services/sys/menu/update', params)
    },
    updateStatus(params){
        return http.fetchPost('/services/sys/menu/updateStatus', params)
    },
    updateByRoleId(params){
        return http.fetchPost('/services/sys/menu/updateByRoleId', params)
    },
    findByRoleId(params){
        return http.fetchPost('/services/sys/menu/findByRoleId', params)
    }
}

export const userServiceApi = {
    update(params){
        return http.fetchPost('/services/sys/user/update', params)
    },
    updateLeader(params){
        return http.fetchPost('/services/sys/user/updateLeader', params)
    },
    delete(params){
        return http.fetchPost('/services/sys/user/delete', params)
    },
    resetMyPwd(params){
        return http.fetchPost('/services/sys/user/resetMyPwd', params)
    },
    getNewKey(){
        return http.fetchPost('/services/sys/user/getNewKey', null)
    },
    resetMyKey(params){
        return http.fetchPost('/services/sys/user/resetMyKey', params)
    },
    resetUser(params){
        return http.fetchPost('/services/sys/user/resetUser', params)
    },
    findMyInfo(){
        return http.fetchPost('/services/sys/user/findMyInfo', null)
    },
    resetMyWithdrawAddress(params){
        return http.fetchPost('/services/sys/user/resetMyWithdrawAddress', params)
    },
    findPageList (params, page) {
        let url = formatURI('/services/sys/user/findPageList/page/{0}/{1}', page.pageSize, page.pageNum)
        return http.fetchPost(url, params)
    },
    login(params){
        return http.fetchPost('/services/login', params)
    },
    login2(params){
        return http.fetchPost('/services/login2', params)
    },
    logout(params){
        return http.fetchPost('/services/logout', params)
    }
}

export const roleServiceApi = {
    update(params){
        return http.fetchPost('/services/sys/role/update', params)
    },
    delete(params){
        return http.fetchPost('/services/sys/role/delete', params)
    },
    findPageList (params, page) {
        let url = formatURI('/services/sys/role/findPageList/page/{0}/{1}', page.pageSize, page.pageNum)
        return http.fetchPost(url, params)
    },
    findAll(){
        return http.fetchPost('/services/sys/role/findAll', null)
    }
}